import { put, takeEvery, select } from 'redux-saga/effects';
import actions from './actions';
import analyticsActions from '../actions';

function* bottomlineInit() {
  try {
    if (window.analyticsTracking) {
      yield put(actions.initSuccess());
    } else {
      throw new Error('Bottomline Analytics is not available.');
    }
  } catch (e) {
    yield put(actions.initFailed(e));
  }
}

function* bottomlineSendScreenview({ payload }) {
  const { analytics, page, refs, ui } = yield select();

  if (analytics.bottomline) {
    try {
      window.analyticsTracking.logEvent('page_view', {
        app_ids: refs.appIds || '',
        app_name: 'OAO',
        app_request_id: refs.appRequestId || '',
        app_version: window.version || '',
        event: 'page_view',
        market: refs.market || '',
        oao_group_name: ui.activeGroup || '',
        oao_page_name: page.name || '',
        page_type: payload || '',
        product: refs.product || '',
        refs,
        status: refs.status || '',
      });

      yield put(actions.sendScreenviewSuccess(payload));
    } catch (e) {
      yield put(actions.sendScreenviewFailed(e));
    }
  }
}

function* bottomlineSendEvent({ payload, type }) {
  const { analytics, page, refs, ui } = yield select();
  const { activeGroup } = ui;

  if (analytics.bottomline) {
    try {
      const { eventCategory, eventLabel } = payload;
      window.analyticsTracking.logEvent(type.toLowerCase(), {
        app_ids: refs.appIds || '',
        app_name: 'OAO',
        app_request_id: refs.appRequestId || '',
        app_version: window.version || '',
        event: type.toLowerCase(),
        event_action: eventCategory || '',
        event_category: eventCategory || '',
        event_label: eventLabel || '',
        market: refs.market || '',
        oao_group_name: activeGroup || '',
        oao_page_name: page.name || '',
        product: refs.product || '',
        refs,
        status: refs.status || '',
      });

      yield put(actions.sendEventSuccess(type));
    } catch (e) {
      yield put(actions.sendEventFailed(e));
    }
  }
}

export default [
  takeEvery(analyticsActions.ANALYTICS_INIT, bottomlineInit),
  takeEvery(analyticsActions.ANALYTICS_SEND_SCREENVIEW, bottomlineSendScreenview),
  takeEvery(
    [
      analyticsActions.FIELD_BLUR,
      analyticsActions.FIELD_ERROR,
      analyticsActions.GOOGLE_PLACES_AUTOCOMPLETE,
      analyticsActions.GROUP,
      analyticsActions.GROUP_NAV,
      analyticsActions.GROUP_SUBMIT,
      analyticsActions.GROUP_SUBMIT_ERROR,
      analyticsActions.GROUP_SUBMIT_SUCCESS,
      analyticsActions.PAGE,
      analyticsActions.PAGE_NAV,
      analyticsActions.PAGE_SUBMIT,
      analyticsActions.PAGE_SUBMIT_ERROR,
      analyticsActions.PAGE_SUBMIT_SUCCESS,
      analyticsActions.SERVER_ERROR,
      analyticsActions.START,
      analyticsActions.TIMEOUT,
      analyticsActions.TIMEOUT_WARNING,
      analyticsActions.TOOLTIP_VIEW,
      analyticsActions.WORKFLOW_END,
    ],
    bottomlineSendEvent,
  ),
];
